<template>
  <section id="WhyUsAsPartners">
    <Wrap class="xl">
      <SectionSplit
        src="../../assets/b2b/why-us.jpg">
        <h4>
          {{ $t('title') }}
        </h4>
        <p v-for="paragraph in $ta('paragraphs')" :key="paragraph">
          {{ paragraph }}
        </p>
        <p v-for="bullet in $ta('bullets')" :key="bullet">
          {{ bullet.title }}
          <ul>
            <li v-for="point in bullet.points" :key="point">
              {{ point }}
            </li>
          </ul>
        </p>
      </SectionSplit>
    </Wrap>
  </section>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: {
    SectionSplit,
  },
}
</script>

<style lang="scss">
#WhyUsAsPartners {
  background-color: $white;

  ul {
    margin: 0.5rem 0 0 2rem;
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "Kodėl verta rinktis Nogrid?",
    "paragraphs": [
      "„Nogrid“ – inovatyvus, patikimas ir kokybę vertinantis saulės energijos sprendimų partneris. Nuo 2016 metų mes įrengėme daugiau nei 2000+ saulės elektrinių Lietuvoje ir už jos ribų. Profesionali projektuotojų ir konsultantų komanda leidžia „Nogrid“ klientams gauti geriausios kokybės paslaugas visuose elektrinės įsigijimo etapuose nuo įrangos pasirinkimo iki jos sumontavimo. Įmonė tiekia Tier1 gamintojų įrangą ir savo klientams siūlo sprendimus, užtikrinančius maksimalų sutaupymą ir greitą atsipirkimą."
    ],
    "bullets": [
      {
        "title": "Nogrid pasiūrpins visais jūsų saulės elektrinės įrengimo aspektais:",
        "points": [
          "Nemokama ekspertų konsultacija",
          "Elektrinių projektavimas",
          "Aukščiausios kokybės įranga",
          "Dokumentacijos tvarkymas",
          "Pagalba teikiant paraišką APVA paramai gauti",
          "Ilgalaikės garantijos"
        ]
      }
    ]
  }
}
</i18n>
